var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"key-item",on:{"click":_vm.openEdit}},[_c('p',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.item.title)+" ")]),_c('p',{staticClass:"content"},[_vm._v(" "+_vm._s(_vm.item.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }